import React from "react";
import { useTheme } from "styled-components";
import { Flex } from "../../Flex";
import { Icon } from "../../Icon";
import { Text } from "../../Text";
import { Button } from "../../Button";
/**
 * The heading of the Flyout.
 * It contains the title, the icon, and the close button.
 */
export const FlyoutHeading = ({ headerIcon, onCloseHandler, title }) => {
    const { colors: { flyoutColors }, } = useTheme();
    return (React.createElement(Flex, { alignItems: "center", boxShadow: "0px 4px 4px 0px #00000010", padding: "24px" },
        React.createElement(Flex, { alignItems: "center", flexGrow: "1", sx: { gap: "16px" } },
            headerIcon && React.createElement(Icon, { src: headerIcon, size: 20 }),
            React.createElement(Text, { fontWeight: "300", fontSize: "20px", color: flyoutColors.flyoutTitle }, title)),
        onCloseHandler && (React.createElement(Button, { variant: "iconWithoutBorder", size: "icon", onClick: onCloseHandler, cursor: "pointer", "data-testid": "closeIcon", color: flyoutColors.closeIcon },
            React.createElement(Icon, { src: "Close", size: 16 })))));
};
